// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompanyProjects-page-QRM5E {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  --bg: #f7f8f9;
  --green: #16a34a;
  --teal: #0f766e;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #f7f8f9;
  background: var(--bg);
  min-height: 100vh;
}

.CompanyProjects-wrap-IxaFF {
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 24px;
}

/* TOP BAR */

.CompanyProjects-topbar-aSbJZ {
  background: #fff;
  border-bottom: 1px solid var(--line);
  position: sticky;
  top: 0;
  z-index: 20;
}

.CompanyProjects-brandRow-DTtj8 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 12px;
  padding: 16px 0;
}

.CompanyProjects-eyebrow-LmZlo {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--red);
}

.CompanyProjects-greeting-yiKQO {
  display: inline-block;
  font-size: 22px;
  font-weight: 800;
  color: #1f2733;
  color: var(--ink, #1f2733);
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.CompanyProjects-topActions-VcoD6 { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 8px; -ms-flex-wrap: wrap; flex-wrap: wrap; }

.CompanyProjects-iconBtn-fK2n1 {
  position: relative;
  border: 1px solid var(--line);
  background: #fff;
  border-radius: 12px;
  width: 42px;
  height: 40px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.CompanyProjects-iconGlyph-lYFGI { font-size: 18px; line-height: 1; }

.CompanyProjects-badge-YaIFE {
  position: absolute;
  top: -7px;
  right: -7px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 20px;
  background: var(--red);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  line-height: 18px;
  text-align: center;
  border: 1.5px solid #fff;
}

.CompanyProjects-sectionTitle-kipHg { font-size: 22px; font-weight: 800; color: #1f2733; color: var(--ink, #1f2733); margin: 6px 0 16px; }

.CompanyProjects-feedRow-bIZSw {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 12px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 10px;
}

.CompanyProjects-feedMain-Ap0iX { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; }

.CompanyProjects-feedTitle-O6QPq { font-size: 14px; font-weight: 700; color: #1f2733; color: var(--ink, #1f2733); display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 8px; }

.CompanyProjects-feedSub-YpvGG { font-size: 12.5px; color: var(--muted); margin-top: 3px; }

.CompanyProjects-dot-MlMYX { width: 9px; height: 9px; border-radius: 50%; background: var(--red); -webkit-box-flex: 0; -ms-flex: none; flex: none; }

.CompanyProjects-newTag-tJbQI { background: var(--red); color: #fff; font-size: 10px; font-weight: 800; padding: 2px 7px; border-radius: 20px; }

.CompanyProjects-openHint-eZkTE { color: var(--muted); font-size: 12.5px; font-weight: 700; white-space: nowrap; }

.CompanyProjects-tabs-GH4EI { display: -webkit-box; display: -ms-flexbox; display: flex; gap: 6px; }

.CompanyProjects-tab-PrLaQ {
  border: 1px solid var(--line);
  background: #fff;
  color: var(--muted);
  font-weight: 700;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 999px;
  cursor: pointer;
  -webkit-transition: all .15s;
  transition: all .15s;
}

.CompanyProjects-tab-PrLaQ:hover { border-color: #c9ccd1; }

.CompanyProjects-tabOn-QVs1q { background: var(--ink); color: #fff; border-color: var(--ink); }

.CompanyProjects-body-WO5_C { padding: 28px 0 64px; }

.CompanyProjects-loading-i0amn { padding: 48px 0; text-align: center; color: var(--muted); font-weight: 600; }

.CompanyProjects-headRow-gF7Yi {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CompanyProjects-h1-AX83m {
  font-size: clamp(24px, 3.6vw, 34px);
  line-height: 1.1;
  font-weight: 800;
  margin: 0 0 6px;
}

.CompanyProjects-sub-yUPlL {
  font-size: 15px;
  color: var(--muted);
  margin: 0;
  line-height: 1.55;
  max-width: 640px;
}

/* SUMMARY */

.CompanyProjects-summaryRow-Rit7_ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
  margin: 0 0 24px;
}

.CompanyProjects-summaryCard-pfnmc, .CompanyProjects-summaryCardWide-jbomY {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 18px 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 4px;
}

.CompanyProjects-summaryNum-DbjJf { font-size: 30px; font-weight: 800; line-height: 1; }

.CompanyProjects-summaryLabel-HguGS { font-size: 13px; color: var(--muted); font-weight: 600; }

.CompanyProjects-summaryCompany-_xpiZ { font-size: 18px; font-weight: 800; }

/* GRID + CARDS */

.CompanyProjects-grid-q1H7c {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 18px;
}

.CompanyProjects-card-XP6TA {
  text-align: left;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 18px 20px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 10px;
  -webkit-transition: border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
  transition: border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
  transition: box-shadow .15s, transform .15s, border-color .15s;
  transition: box-shadow .15s, transform .15s, border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
  font: inherit;
  color: inherit;
}

.CompanyProjects-card-XP6TA:hover {
  -webkit-box-shadow: 0 14px 34px rgba(15, 18, 20, 0.10);
          box-shadow: 0 14px 34px rgba(15, 18, 20, 0.10);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
  border-color: #d7dadf;
}

.CompanyProjects-cardTop-TflUr { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; gap: 8px; }

.CompanyProjects-catPill-b3zcc {
  display: inline-block;
  background: #fff0ef;
  color: var(--red-d);
  font-weight: 800;
  font-size: 12px;
  letter-spacing: .02em;
  padding: 5px 12px;
  border-radius: 999px;
}

.CompanyProjects-scorePill-oCbfO {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
  color: var(--teal);
}

.CompanyProjects-scorePill-oCbfO svg { width: 14px; height: 14px; }

.CompanyProjects-cardTitle-eNtqC { font-size: 18px; font-weight: 800; margin: 0; line-height: 1.25; }

.CompanyProjects-cardMetaRow-xZRCW { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; gap: 14px; }

.CompanyProjects-cardMeta-FTwmq {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  font-size: 13.5px;
  color: var(--muted);
  font-weight: 600;
}

.CompanyProjects-cardMeta-FTwmq svg { width: 16px; height: 16px; color: var(--ink); opacity: .55; }

.CompanyProjects-cardFoot-H2Qew {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  border-top: 1px solid var(--line);
  padding-top: 12px;
  margin-top: 2px;
}

.CompanyProjects-cardRef-TXLKn { font-size: 12.5px; color: var(--muted); font-weight: 700; }

.CompanyProjects-cardCta-pZV5h { font-size: 14px; font-weight: 800; color: var(--red); }

/* EMPTY STATE */

.CompanyProjects-empty-FCjkJ {
  background: #fff;
  border: 1px dashed #d7dadf;
  border-radius: 20px;
  padding: 48px 24px;
  text-align: center;
}

.CompanyProjects-emptyImg-zn3xJ { width: 120px; height: auto; margin: 0 auto 12px; display: block; }

.CompanyProjects-emptyTitle-ltWnl { font-size: 20px; font-weight: 800; margin: 0 0 8px; }

.CompanyProjects-emptyBody-NWWZD { font-size: 15px; color: var(--muted); max-width: 420px; margin: 0 auto; line-height: 1.55; }

/* ALERTS */

.CompanyProjects-alertErr-NaPA4, .CompanyProjects-alertWarn-uWNtq {
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 16px;
  line-height: 1.45;
}

.CompanyProjects-alertErr-NaPA4 { background: #fff0ef; color: var(--red-d); border: 1px solid #f6c9c7; }

.CompanyProjects-alertWarn-uWNtq { background: #fff8e6; color: #92611a; border: 1px solid #f1deb0; }

/* GATE */

.CompanyProjects-gate-xoLws {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 48px 32px;
  text-align: center;
  max-width: 560px;
  margin: 24px auto;
}

.CompanyProjects-gateTitle-xw62t { font-size: 26px; font-weight: 800; margin: 0 0 10px; }

.CompanyProjects-gateBody-w8Vmb { font-size: 15.5px; color: var(--muted); line-height: 1.6; margin: 0 0 22px; }

/* BUTTONS */

.CompanyProjects-btn-iuTM4 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  background: var(--red);
  color: #fff;
  border: none;
  font-weight: 800;
  font-size: 15px;
  padding: 12px 22px;
  border-radius: 12px;
  cursor: pointer;
  text-decoration: none;
  -webkit-transition: background .15s;
  transition: background .15s;
}

.CompanyProjects-btn-iuTM4:hover { background: var(--red-d); }

.CompanyProjects-btn-iuTM4:disabled { opacity: .55; cursor: default; }

.CompanyProjects-btnGhost-j3f4a {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
  font-weight: 800;
  font-size: 14px;
  padding: 10px 18px;
  border-radius: 12px;
  cursor: pointer;
}

.CompanyProjects-btnGhost-j3f4a:hover { border-color: #c9ccd1; }

.CompanyProjects-backBtn-fGs8Q {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--muted);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
  margin-bottom: 14px;
}

.CompanyProjects-backBtn-fGs8Q:hover { color: var(--ink); }

.CompanyProjects-backBtn-fGs8Q svg { width: 18px; height: 18px; }

/* DETAIL */

.CompanyProjects-detailHead-juhKC { margin-bottom: 20px; }

.CompanyProjects-detailHead-juhKC .CompanyProjects-catPill-b3zcc { margin-bottom: 10px; }

.CompanyProjects-privacyNote-AQp4U {
  font-size: 13px;
  color: var(--muted);
  margin: 8px 0 0;
  font-style: italic;
}

.CompanyProjects-detailGrid-RITRZ {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 22px;
  margin-bottom: 26px;
}

.CompanyProjects-detailMain-M27UJ { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 18px; }

.CompanyProjects-block-sAYms {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 20px 22px;
}

.CompanyProjects-blockTitle-zwJFc { font-size: 16px; font-weight: 800; margin: 0 0 12px; }

.CompanyProjects-blockText-rn8HU { font-size: 15px; color: #2a2f34; line-height: 1.6; margin: 0; white-space: pre-line; }

.CompanyProjects-photoGrid-Slerj {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 12px;
}

.CompanyProjects-photoCell-SzArm {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 4 / 3;
  background: var(--bg);
  border: 1px solid var(--line);
}

.CompanyProjects-photoCell-SzArm img { width: 100%; height: 100%; -o-object-fit: cover; object-fit: cover; display: block; }

.CompanyProjects-photoPlaceholder-GKwy3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center;
  width: 100%; height: 100%; color: #b8bcc2;
}

.CompanyProjects-photoPlaceholder-GKwy3 svg { width: 30px; height: 30px; }

.CompanyProjects-photoSlot-ChrY6 {
  position: absolute; left: 0; right: 0; bottom: 0;
  background: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0,0,0,.62)));
  background: linear-gradient(transparent, rgba(0,0,0,.62));
  color: #fff; font-size: 11px; font-weight: 700;
  padding: 14px 8px 6px; text-transform: capitalize;
}

.CompanyProjects-detailSide-PU7_A { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 16px; }

.CompanyProjects-factCard-oUnAo {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 20px 22px;
  position: sticky;
  top: 84px;
}

.CompanyProjects-dl-KL0qp { display: grid; grid-template-columns: auto 1fr; gap: 8px 16px; margin: 0; }

.CompanyProjects-dl-KL0qp dt { font-size: 13px; color: var(--muted); font-weight: 700; }

.CompanyProjects-dl-KL0qp dd { font-size: 14px; margin: 0; text-align: right; font-weight: 600; text-transform: capitalize; }

/* QUOTE FORM */

.CompanyProjects-quoteCard-nQ87W {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 26px 26px 28px;
}

.CompanyProjects-quoteTitle-cCfVy { font-size: 22px; font-weight: 800; margin: 0 0 6px; }

.CompanyProjects-lineHead-LQ4SF, .CompanyProjects-lineRow-y9HXn {
  display: grid;
  grid-template-columns: 1fr 80px 130px 110px 34px;
  gap: 10px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.CompanyProjects-lineHead-LQ4SF {
  margin: 16px 0 8px;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: var(--muted);
}

.CompanyProjects-lineRow-y9HXn { margin-bottom: 8px; }

.CompanyProjects-lhDesc-lTuZ1 {}

.CompanyProjects-lhQty-ku9wa { text-align: left; }

.CompanyProjects-lhUnit-lAecL {}

.CompanyProjects-lhTotal-jCGdQ { text-align: right; }

.CompanyProjects-lhDel-TlWba {}

.CompanyProjects-lineTotalCell-hHKwd { font-weight: 800; font-size: 15px; }

.CompanyProjects-lineDel-X1xut {
  background: var(--bg);
  border: 1px solid var(--line);
  color: var(--muted);
  width: 32px; height: 32px;
  border-radius: 8px;
  font-size: 20px; line-height: 1;
  cursor: pointer;
}

.CompanyProjects-lineDel-X1xut:hover { color: var(--red); border-color: #f6c9c7; }

.CompanyProjects-addLine-UkEwo {
  background: none; border: none; color: var(--red);
  font-weight: 800; font-size: 14px; cursor: pointer;
  padding: 6px 0; margin: 2px 0 6px;
}

.CompanyProjects-input-cazeM {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 10px 12px;
  font: inherit;
  font-size: 14px;
  background: #fff;
  color: var(--ink);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.CompanyProjects-input-cazeM:focus { outline: none; border-color: var(--red); -webkit-box-shadow: 0 0 0 3px rgba(232,35,43,.12); box-shadow: 0 0 0 3px rgba(232,35,43,.12); }

.CompanyProjects-quoteMetaGrid-psKrW {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 14px;
  margin: 18px 0 4px;
}

.CompanyProjects-field-yMLKS { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 6px; }

.CompanyProjects-field-yMLKS > span { font-size: 13px; font-weight: 700; color: var(--muted); }

.CompanyProjects-totals-q0iD4 {
  margin: 18px 0 4px;
  border-top: 1px solid var(--line);
  padding-top: 14px;
  max-width: 320px;
  margin-left: auto;
}

.CompanyProjects-totalRow-dmxm0 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between;
  font-size: 14px; color: var(--muted); font-weight: 600;
  padding: 4px 0;
}

.CompanyProjects-totalGrand-Jm9hx {
  font-size: 18px; color: var(--ink); font-weight: 800;
  border-top: 1px solid var(--line); margin-top: 6px; padding-top: 10px;
}

.CompanyProjects-quoteActions-Z3Kl2 { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: end; -ms-flex-pack: end; justify-content: flex-end; margin-top: 18px; }

/* E4 — two-sided payment breakdown (company quote builder) */

.CompanyProjects-breakdown-OBsla {
  margin: 20px 0 4px;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 18px 20px;
  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(var(--bg)));
  background: linear-gradient(180deg, #fff 0%, var(--bg) 100%);
}

.CompanyProjects-bkHead-QlF4V {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between;
  gap: 12px; -ms-flex-wrap: wrap; flex-wrap: wrap; margin-bottom: 6px;
}

.CompanyProjects-bkTitle-anMlr { font-size: 15px; font-weight: 800; color: var(--ink); }

.CompanyProjects-modeBadge-yyF6Q {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 800; letter-spacing: .02em;
  padding: 6px 12px; border-radius: 999px;
}

.CompanyProjects-modeBadge-yyF6Q svg { width: 14px; height: 14px; }

.CompanyProjects-modeMilestone-O0Bue { background: #e7f0ff; color: #1d4ed8; }

.CompanyProjects-modeFull-mQt0q { background: #e7f8ee; color: var(--green); }

.CompanyProjects-bkRow-imwKE {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between;
  gap: 16px; padding: 12px 0; border-top: 1px solid var(--line);
}

.CompanyProjects-bkRow-imwKE:first-of-type { border-top: none; }

.CompanyProjects-bkLabel-aF4es { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 2px; }

.CompanyProjects-bkName-x2k4N { font-size: 14px; font-weight: 700; color: var(--ink); }

.CompanyProjects-bkHint-PeH1A { font-size: 12.5px; color: var(--muted); font-weight: 600; }

.CompanyProjects-bkVal-Mext9 { font-size: 17px; font-weight: 800; color: var(--ink); white-space: nowrap; }

.CompanyProjects-bkValClient-bq1zM { color: var(--ink); }

.CompanyProjects-bkRowNet-d9NUS {
  background: #fbfdfb; margin: 0 -20px -2px; padding: 14px 20px;
  border-top: 1px solid var(--line); border-radius: 0 0 16px 16px;
}

.CompanyProjects-bkValNet-let1M { color: var(--green); }

.CompanyProjects-bkNote-_KCB7 {
  margin: 12px 0 0; font-size: 12.5px; color: var(--muted);
  font-weight: 600; line-height: 1.5;
}

/* MY QUOTES */

.CompanyProjects-quoteList-e5HhD { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 12px; }

.CompanyProjects-quoteRow-vRZlE {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 16px 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 18px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CompanyProjects-quoteRowMain-A10l9 { -webkit-box-flex: 1; -ms-flex: 1 1; flex: 1 1; min-width: 160px; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 2px; }

.CompanyProjects-quoteRef-cF87Z { font-weight: 800; font-size: 15px; }

.CompanyProjects-quoteSubtitle-Ib63n { font-size: 13px; color: var(--muted); font-weight: 600; }

.CompanyProjects-quoteRowMeta-CpbHd { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; -webkit-box-align: end; -ms-flex-align: end; align-items: flex-end; gap: 2px; }

.CompanyProjects-quoteAmount-JCMQG { font-weight: 800; font-size: 16px; }

.CompanyProjects-quoteDays-xkwIW { font-size: 12.5px; color: var(--muted); font-weight: 600; }

.CompanyProjects-statusPill-M2_yc {
  font-size: 12px; font-weight: 800; letter-spacing: .03em;
  padding: 6px 12px; border-radius: 999px;
  background: var(--bg); color: var(--muted);
  text-transform: uppercase;
}

.CompanyProjects-st_draft-c2ahd { background: #eef0f2; color: #5a6168; }

.CompanyProjects-st_submitted-ddgTt { background: #e7f0ff; color: #1d4ed8; }

.CompanyProjects-st_selected-QePxP { background: #e7f8ee; color: var(--green); }

.CompanyProjects-st_rejected-wQlQj { background: #fff0ef; color: var(--red-d); }

.CompanyProjects-st_expired-ZIi_b, .CompanyProjects-st_withdrawn-jWpnL { background: #f3f0e7; color: #92611a; }

/* =========================================================================
   DASHBOARD (lightweight CRM)
   ========================================================================= */

/* KPI cards */

.CompanyProjects-kpiRow-_qZY_ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
  margin: 0 0 26px;
}

.CompanyProjects-kpiCard-Mfwj6 {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 20px 22px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 4px;
  position: relative;
  overflow: hidden;
  -webkit-transition: border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
  transition: border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
  transition: box-shadow .15s, transform .15s, border-color .15s;
  transition: box-shadow .15s, transform .15s, border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
}

.CompanyProjects-kpiCard-Mfwj6:hover {
  -webkit-box-shadow: 0 14px 34px rgba(15, 18, 20, 0.08);
          box-shadow: 0 14px 34px rgba(15, 18, 20, 0.08);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
  border-color: #d7dadf;
}

.CompanyProjects-kpiIcon-_2U6l {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #fff0ef;
  color: var(--red);
  margin-bottom: 8px;
}

.CompanyProjects-kpiIcon-_2U6l svg { width: 20px; height: 20px; }

.CompanyProjects-kpiNum-G74wi { font-size: 30px; font-weight: 800; line-height: 1.05; }

.CompanyProjects-kpiLabel-Ojuko { font-size: 13.5px; font-weight: 700; color: var(--ink); }

.CompanyProjects-kpiHint-hdCNZ { font-size: 12.5px; color: var(--muted); font-weight: 600; }

.CompanyProjects-kpiCardMoney-kPpKj {
  background: linear-gradient(160deg, #ffffff 0%, #f3fbf5 100%);
  border-color: #cdebd6;
}

.CompanyProjects-kpiCardMoney-kPpKj .CompanyProjects-kpiIcon-_2U6l { background: #e7f8ee; color: var(--green); }

.CompanyProjects-kpiCardMoney-kPpKj .CompanyProjects-kpiNum-G74wi { color: var(--green); }

/* Dashboard sections */

.CompanyProjects-dashBlock-AQqAT { margin: 0 0 28px; }

.CompanyProjects-dashBlockHead-CqNR_ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  margin: 0 0 12px;
}

.CompanyProjects-dashTitle-O7DBV { font-size: 18px; font-weight: 800; margin: 0; }

.CompanyProjects-dashCount-wt5vQ {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--bg);
  border: 1px solid var(--line);
  font-size: 12.5px;
  font-weight: 800;
  color: var(--muted);
}

.CompanyProjects-dashTotalBadge-hrGHF {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  margin-left: auto;
  font-size: 13px;
  font-weight: 800;
  color: var(--green);
  background: #e7f8ee;
  border-radius: 999px;
  padding: 6px 14px;
}

.CompanyProjects-dashTotalBadge-hrGHF svg { width: 15px; height: 15px; }

.CompanyProjects-dashList-VV0rt { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 10px; }

.CompanyProjects-dashItem-jXd8c {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 15px 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-transition: border-color .15s;
  transition: border-color .15s;
}

.CompanyProjects-dashItem-jXd8c:hover { border-color: #d7dadf; }

.CompanyProjects-dashItemMain-x98x0 { -webkit-box-flex: 1; -ms-flex: 1 1; flex: 1 1; min-width: 180px; display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 3px; }

.CompanyProjects-dashItemTitle-DTo4v {
  font-size: 15px;
  font-weight: 800;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
}

.CompanyProjects-dashItemSub-LlZep { font-size: 13px; color: var(--muted); font-weight: 600; line-height: 1.4; }

.CompanyProjects-dashItemAmount-ff7K5 { font-size: 16px; font-weight: 800; white-space: nowrap; }

/* Milestones grouped per contract */

.CompanyProjects-msGroup-JngJj {
  border: 1px solid var(--line);
  border-radius: 16px;
  background: #fff;
  padding: 16px 18px;
  margin-bottom: 12px;
}

.CompanyProjects-msGroupHead-g5vDm {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 12px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  padding-bottom: 12px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--line);
}

.CompanyProjects-msGroupTitle-qvAnZ { font-size: 15px; font-weight: 800; }

.CompanyProjects-msGroupSub-DI8Ak { font-size: 13px; color: var(--muted); font-weight: 700; }

.CompanyProjects-msRow-IuCdF {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  padding: 12px 0;
  border-bottom: 1px solid var(--line);
}

.CompanyProjects-msRow-IuCdF:last-child { border-bottom: none; padding-bottom: 2px; }

.CompanyProjects-msTag-I86hX {
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: var(--teal);
  background: #e6f4f2;
  border-radius: 6px;
  padding: 2px 7px;
}

/* extra status-pill colors for contracts / milestones / payouts */

.CompanyProjects-st_active-F4CxA { background: #e7f8ee; color: var(--green); }

.CompanyProjects-st_in_cancellation_period-ZOkvJ { background: #fff8e6; color: #92611a; }

.CompanyProjects-st_completed-iuW7D { background: #eef0f2; color: #5a6168; }

.CompanyProjects-st_cancelled-gxZrw { background: #fff0ef; color: var(--red-d); }

.CompanyProjects-st_ready-faNxx { background: #eef0f2; color: #5a6168; }

.CompanyProjects-st_in_progress-Mi0wJ { background: #e7f0ff; color: #1d4ed8; }

.CompanyProjects-st_submitted_for_review-UQ8dN { background: #f3ecff; color: #6d28d9; }

.CompanyProjects-st_paid-cRqW2 { background: #e7f8ee; color: var(--green); }

.CompanyProjects-st_pending-yMKhq { background: #fff8e6; color: #92611a; }

.CompanyProjects-st_transferred-yE_DA { background: #e7f8ee; color: var(--green); }

.CompanyProjects-st_reversed-FGf0V { background: #fff0ef; color: var(--red-d); }

/* AI quote-drafting assistant (DRAFT ONLY) */

.CompanyProjects-aiBox-iPRXH {
  border: 1px solid var(--line);
  border-radius: 14px;
  background: -webkit-gradient(linear, left top, left bottom, from(#fafbfc), to(#fff));
  background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
  padding: 16px;
  margin: 4px 0 18px;
}

.CompanyProjects-aiHead-v05Dq {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
}

.CompanyProjects-aiTitle-x8xvX { display: block; font-size: 15px; font-weight: 800; color: var(--ink); }

.CompanyProjects-aiHint-lgImi { display: block; margin-top: 3px; font-size: 13px; color: var(--muted); max-width: 520px; }

.CompanyProjects-aiFallback-DO_zO {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff8e6;
  color: #92611a;
  font-size: 13px;
  border: 1px solid #f3e3b3;
}

.CompanyProjects-aiFollow-NBJl5 {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #eef4ff;
  color: #1d4ed8;
  font-size: 13px;
  border: 1px solid #cfe0ff;
}

@media (max-width: 880px) {
  .CompanyProjects-detailGrid-RITRZ { grid-template-columns: 1fr; }
  .CompanyProjects-factCard-oUnAo { position: static; }
  .CompanyProjects-lineHead-LQ4SF { display: none; }
  .CompanyProjects-lineRow-y9HXn { grid-template-columns: 1fr 1fr; grid-auto-rows: auto; }
  .CompanyProjects-lhTotal-jCGdQ { text-align: left; }
  .CompanyProjects-aiHead-v05Dq { -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; }
}
`, "",{"version":3,"sources":["webpack://./src/routes/company-projects/CompanyProjects.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,mBAAqB;EAArB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;;AACZ;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAe;MAAf,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AACA,oCAAc,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ,EAAE,mBAAe,EAAf,eAAe,EAAE;;AAC7E;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA,mCAAa,eAAe,EAAE,cAAc,EAAE;;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AACA,sCAAgB,eAAe,EAAE,gBAAgB,EAAE,cAA0B,EAA1B,0BAA0B,EAAE,kBAAkB,EAAE;;AACnG;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA,kCAAY,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE;;AACnD,mCAAa,eAAe,EAAE,gBAAgB,EAAE,cAA0B,EAA1B,0BAA0B,EAAE,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ,EAAE;;AAC1H,iCAAW,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AACpE,6BAAO,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,mBAAU,EAAV,cAAU,EAAV,UAAU,EAAE;;AACxF,gCAAU,sBAAsB,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AACzH,kCAAY,mBAAmB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAC3F,8BAAQ,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,QAAQ,EAAE;;AACjC;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,4BAAoB;EAApB,oBAAoB;AACtB;;AACA,mCAAa,qBAAqB,EAAE;;AACpC,+BAAS,sBAAsB,EAAE,WAAW,EAAE,wBAAwB,EAAE;;AAExE,8BAAQ,oBAAoB,EAAE;;AAC9B,iCAAW,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEvF;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,YAAY;;AACZ;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;AACV;;AACA,oCAAc,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AACjE,sCAAgB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACxE,wCAAkB,eAAe,EAAE,gBAAgB,EAAE;;AAErD,iBAAiB;;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,sFAA8D;EAA9D,8EAA8D;EAA9D,8DAA8D;EAA9D,+GAA8D;EAC9D,aAAa;EACb,cAAc;AAChB;;AACA;EACE,sDAA8C;UAA9C,8CAA8C;EAC9C,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,qBAAqB;AACvB;;AACA,iCAAW,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,QAAQ,EAAE;;AACzF;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AACA,uCAAiB,WAAW,EAAE,YAAY,EAAE;;AAC5C,mCAAa,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE,iBAAiB,EAAE;;AAC9E,qCAAe,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,mBAAe,EAAf,eAAe,EAAE,SAAS,EAAE;;AAC1D;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA,sCAAgB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,YAAY,EAAE;;AAC5E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;AACjB;;AACA,iCAAW,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACrE,iCAAW,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEjE,gBAAgB;;AAChB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AACA,kCAAY,YAAY,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAC7E,oCAAc,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAClE,mCAAa,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAExG,WAAW;;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AACA,kCAAY,mBAAmB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;;AACjF,mCAAa,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE7E,SAAS;;AACT;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AACA,mCAAa,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAClE,kCAAY,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAExF,YAAY;;AACZ;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,mCAA2B;EAA3B,2BAA2B;AAC7B;;AACA,mCAAa,wBAAwB,EAAE;;AACvC,sCAAgB,YAAY,EAAE,eAAe,EAAE;;AAC/C;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AACA,wCAAkB,qBAAqB,EAAE;;AAEzC;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AACA,uCAAiB,iBAAiB,EAAE;;AACpC,qCAAe,WAAW,EAAE,YAAY,EAAE;;AAE1C,WAAW;;AACX,oCAAc,mBAAmB,EAAE;;AACnC,mEAAuB,mBAAmB,EAAE;;AAC5C;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AACA,oCAAc,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,SAAS,EAAE;;AAChE;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AACA,oCAAc,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AACnE,mCAAa,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,SAAS,EAAE,qBAAqB,EAAE;;AAElG;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AACA,uCAAiB,WAAW,EAAE,YAAY,EAAE,oBAAiB,EAAjB,iBAAiB,EAAE,cAAc,EAAE;;AAC/E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,wBAAuB,EAAvB,qBAAuB,EAAvB,uBAAuB;EAC3D,WAAW,EAAE,YAAY,EAAE,cAAc;AAC3C;;AACA,8CAAwB,WAAW,EAAE,YAAY,EAAE;;AACnD;EACE,kBAAkB,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EAChD,mGAAyD;EAAzD,yDAAyD;EACzD,WAAW,EAAE,eAAe,EAAE,gBAAgB;EAC9C,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA,oCAAc,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,SAAS,EAAE;;AAChE;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,4BAAM,aAAa,EAAE,+BAA+B,EAAE,aAAa,EAAE,SAAS,EAAE;;AAChF,+BAAS,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACjE,+BAAS,eAAe,EAAE,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEtG,eAAe;;AACf;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;AACzB;;AACA,oCAAc,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAElE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AACA,iCAAW,kBAAkB,EAAE;;AAC/B,+BAAS;;AACT,+BAAS,gBAAgB,EAAE;;AAC3B,+BAAS;;AACT,iCAAW,iBAAiB,EAAE;;AAC9B,8BAAQ;;AACR,uCAAiB,gBAAgB,EAAE,eAAe,EAAE;;AACpD;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,eAAe,EAAE,cAAc;EAC/B,eAAe;AACjB;;AACA,uCAAiB,iBAAiB,EAAE,qBAAqB,EAAE;;AAC3D;EACE,gBAAgB,EAAE,YAAY,EAAE,iBAAiB;EACjD,gBAAgB,EAAE,eAAe,EAAE,eAAe;EAClD,cAAc,EAAE,iBAAiB;AACnC;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAAsB;UAAtB,sBAAsB;AACxB;;AACA,qCAAe,aAAa,EAAE,wBAAwB,EAAE,iDAAyC,EAAzC,yCAAyC,EAAE;;AAEnG;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AACA,+BAAS,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,QAAQ,EAAE;;AAC1D,sCAAgB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAExE;EACE,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B;EAC7C,eAAe,EAAE,mBAAmB,EAAE,gBAAgB;EACtD,cAAc;AAChB;;AACA;EACE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB;EACpD,iCAAiC,EAAE,eAAe,EAAE,iBAAiB;AACvE;;AACA,sCAAgB,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,qBAAyB,EAAzB,kBAAyB,EAAzB,yBAAyB,EAAE,gBAAgB,EAAE;;AAE5E,6DAA6D;;AAC7D;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,sFAA4D;EAA5D,4DAA4D;AAC9D;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B;EAClE,SAAS,EAAE,mBAAe,EAAf,eAAe,EAAE,kBAAkB;AAChD;;AACA,iCAAW,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AACjE;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ;EACnD,eAAe,EAAE,gBAAgB,EAAE,qBAAqB;EACxD,iBAAiB,EAAE,oBAAoB;AACzC;;AACA,uCAAiB,WAAW,EAAE,YAAY,EAAE;;AAC5C,uCAAiB,mBAAmB,EAAE,cAAc,EAAE;;AACtD,kCAAY,mBAAmB,EAAE,mBAAmB,EAAE;;AACtD;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B;EAClE,SAAS,EAAE,eAAe,EAAE,iCAAiC;AAC/D;;AACA,6CAAuB,gBAAgB,EAAE;;AACzC,iCAAW,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,QAAQ,EAAE;;AAC5D,gCAAU,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAChE,gCAAU,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACpE,+BAAS,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;AACpF,qCAAe,iBAAiB,EAAE;;AAClC;EACE,mBAAmB,EAAE,oBAAoB,EAAE,kBAAkB;EAC7D,iCAAiC,EAAE,4BAA4B;AACjE;;AACA,kCAAY,mBAAmB,EAAE;;AACjC;EACE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB;EACxD,gBAAgB,EAAE,gBAAgB;AACpC;;AAEA,cAAc;;AACd,mCAAa,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,SAAS,EAAE;;AAC/D;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AACA,sCAAgB,mBAAO,EAAP,aAAO,EAAP,SAAO,EAAE,gBAAgB,EAAE,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,QAAQ,EAAE;;AAC5F,kCAAY,gBAAgB,EAAE,eAAe,EAAE;;AAC/C,uCAAiB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACzE,sCAAgB,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,sBAAqB,EAArB,mBAAqB,EAArB,qBAAqB,EAAE,QAAQ,EAAE;;AACxF,qCAAe,gBAAgB,EAAE,eAAe,EAAE;;AAClD,mCAAa,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACvE;EACE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB;EACxD,iBAAiB,EAAE,oBAAoB;EACvC,qBAAqB,EAAE,mBAAmB;EAC1C,yBAAyB;AAC3B;;AACA,kCAAY,mBAAmB,EAAE,cAAc,EAAE;;AACjD,sCAAgB,mBAAmB,EAAE,cAAc,EAAE;;AACrD,qCAAe,mBAAmB,EAAE,mBAAmB,EAAE;;AACzD,qCAAe,mBAAmB,EAAE,mBAAmB,EAAE;;AACzD,yEAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE;;8EAE8E;;AAE9E,cAAc;;AACd;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,sFAA8D;EAA9D,8EAA8D;EAA9D,8DAA8D;EAA9D,+GAA8D;AAChE;;AACA;EACE,sDAA8C;UAA9C,8CAA8C;EAC9C,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,qBAAqB;AACvB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AACA,qCAAe,WAAW,EAAE,YAAY,EAAE;;AAC1C,gCAAU,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAChE,kCAAY,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AACpE,iCAAW,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACrE;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AACA,qEAAyB,mBAAmB,EAAE,mBAAmB,EAAE;;AACnE,oEAAwB,mBAAmB,EAAE;;AAE7C,uBAAuB;;AACvB,mCAAa,gBAAgB,EAAE;;AAC/B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AACA,mCAAa,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAC3D;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AACA,4CAAsB,WAAW,EAAE,YAAY,EAAE;;AAEjD,kCAAY,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,SAAS,EAAE;;AAC9D;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,qCAA6B;EAA7B,6BAA6B;AAC/B;;AACA,wCAAkB,qBAAqB,EAAE;;AACzC,sCAAgB,mBAAO,EAAP,aAAO,EAAP,SAAO,EAAE,gBAAgB,EAAE,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,QAAQ,EAAE;;AAC5F;EACE,eAAe;EACf,gBAAgB;EAChB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AACA,qCAAe,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AACzF,wCAAkB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE1E,oCAAoC;;AACpC;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;EACrB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oCAAoC;AACtC;;AACA,sCAAgB,eAAe,EAAE,gBAAgB,EAAE;;AACnD,oCAAc,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACtE;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,eAAe;EACf,oCAAoC;AACtC;;AACA,0CAAoB,mBAAmB,EAAE,mBAAmB,EAAE;;AAC9D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kEAAkE;;AAClE,mCAAa,mBAAmB,EAAE,mBAAmB,EAAE;;AACvD,mDAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAClE,sCAAgB,mBAAmB,EAAE,cAAc,EAAE;;AACrD,sCAAgB,mBAAmB,EAAE,mBAAmB,EAAE;;AAC1D,kCAAY,mBAAmB,EAAE,cAAc,EAAE;;AACjD,wCAAkB,mBAAmB,EAAE,cAAc,EAAE;;AACvD,iDAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAChE,iCAAW,mBAAmB,EAAE,mBAAmB,EAAE;;AACrD,oCAAc,mBAAmB,EAAE,cAAc,EAAE;;AACnD,wCAAkB,mBAAmB,EAAE,mBAAmB,EAAE;;AAC5D,qCAAe,mBAAmB,EAAE,mBAAmB,EAAE;;AAEzD,6CAA6C;;AAC7C;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oFAA0D;EAA1D,0DAA0D;EAC1D,aAAa;EACb,kBAAkB;AACpB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;AACX;;AACA,iCAAW,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AACjF,gCAAU,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACnG;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAc,0BAA0B,EAAE;EAC1C,kCAAY,gBAAgB,EAAE;EAC9B,kCAAY,aAAa,EAAE;EAC3B,iCAAW,8BAA8B,EAAE,oBAAoB,EAAE;EACjE,iCAAW,gBAAgB,EAAE;EAC7B,gCAAU,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE;AACpC","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  --bg: #f7f8f9;\n  --green: #16a34a;\n  --teal: #0f766e;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: var(--bg);\n  min-height: 100vh;\n}\n\n.wrap {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* TOP BAR */\n.topbar {\n  background: #fff;\n  border-bottom: 1px solid var(--line);\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n.brandRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 16px 0;\n}\n.eyebrow {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--red);\n}\n.greeting {\n  display: inline-block;\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--ink, #1f2733);\n  max-width: 60%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.topActions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\n.iconBtn {\n  position: relative;\n  border: 1px solid var(--line);\n  background: #fff;\n  border-radius: 12px;\n  width: 42px;\n  height: 40px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.iconGlyph { font-size: 18px; line-height: 1; }\n.badge {\n  position: absolute;\n  top: -7px;\n  right: -7px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 20px;\n  background: var(--red);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 18px;\n  text-align: center;\n  border: 1.5px solid #fff;\n}\n.sectionTitle { font-size: 22px; font-weight: 800; color: var(--ink, #1f2733); margin: 6px 0 16px; }\n.feedRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 14px 16px;\n  margin-bottom: 10px;\n}\n.feedMain { display: flex; flex-direction: column; }\n.feedTitle { font-size: 14px; font-weight: 700; color: var(--ink, #1f2733); display: flex; align-items: center; gap: 8px; }\n.feedSub { font-size: 12.5px; color: var(--muted); margin-top: 3px; }\n.dot { width: 9px; height: 9px; border-radius: 50%; background: var(--red); flex: none; }\n.newTag { background: var(--red); color: #fff; font-size: 10px; font-weight: 800; padding: 2px 7px; border-radius: 20px; }\n.openHint { color: var(--muted); font-size: 12.5px; font-weight: 700; white-space: nowrap; }\n.tabs { display: flex; gap: 6px; }\n.tab {\n  border: 1px solid var(--line);\n  background: #fff;\n  color: var(--muted);\n  font-weight: 700;\n  font-size: 14px;\n  padding: 8px 16px;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all .15s;\n}\n.tab:hover { border-color: #c9ccd1; }\n.tabOn { background: var(--ink); color: #fff; border-color: var(--ink); }\n\n.body { padding: 28px 0 64px; }\n.loading { padding: 48px 0; text-align: center; color: var(--muted); font-weight: 600; }\n\n.headRow {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n  flex-wrap: wrap;\n}\n.h1 {\n  font-size: clamp(24px, 3.6vw, 34px);\n  line-height: 1.1;\n  font-weight: 800;\n  margin: 0 0 6px;\n}\n.sub {\n  font-size: 15px;\n  color: var(--muted);\n  margin: 0;\n  line-height: 1.55;\n  max-width: 640px;\n}\n\n/* SUMMARY */\n.summaryRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 14px;\n  margin: 0 0 24px;\n}\n.summaryCard, .summaryCardWide {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.summaryNum { font-size: 30px; font-weight: 800; line-height: 1; }\n.summaryLabel { font-size: 13px; color: var(--muted); font-weight: 600; }\n.summaryCompany { font-size: 18px; font-weight: 800; }\n\n/* GRID + CARDS */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 18px;\n}\n.card {\n  text-align: left;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 18px 20px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: box-shadow .15s, transform .15s, border-color .15s;\n  font: inherit;\n  color: inherit;\n}\n.card:hover {\n  box-shadow: 0 14px 34px rgba(15, 18, 20, 0.10);\n  transform: translateY(-2px);\n  border-color: #d7dadf;\n}\n.cardTop { display: flex; align-items: center; justify-content: space-between; gap: 8px; }\n.catPill {\n  display: inline-block;\n  background: #fff0ef;\n  color: var(--red-d);\n  font-weight: 800;\n  font-size: 12px;\n  letter-spacing: .02em;\n  padding: 5px 12px;\n  border-radius: 999px;\n}\n.scorePill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--teal);\n}\n.scorePill svg { width: 14px; height: 14px; }\n.cardTitle { font-size: 18px; font-weight: 800; margin: 0; line-height: 1.25; }\n.cardMetaRow { display: flex; flex-wrap: wrap; gap: 14px; }\n.cardMeta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13.5px;\n  color: var(--muted);\n  font-weight: 600;\n}\n.cardMeta svg { width: 16px; height: 16px; color: var(--ink); opacity: .55; }\n.cardFoot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--line);\n  padding-top: 12px;\n  margin-top: 2px;\n}\n.cardRef { font-size: 12.5px; color: var(--muted); font-weight: 700; }\n.cardCta { font-size: 14px; font-weight: 800; color: var(--red); }\n\n/* EMPTY STATE */\n.empty {\n  background: #fff;\n  border: 1px dashed #d7dadf;\n  border-radius: 20px;\n  padding: 48px 24px;\n  text-align: center;\n}\n.emptyImg { width: 120px; height: auto; margin: 0 auto 12px; display: block; }\n.emptyTitle { font-size: 20px; font-weight: 800; margin: 0 0 8px; }\n.emptyBody { font-size: 15px; color: var(--muted); max-width: 420px; margin: 0 auto; line-height: 1.55; }\n\n/* ALERTS */\n.alertErr, .alertWarn {\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 16px;\n  line-height: 1.45;\n}\n.alertErr { background: #fff0ef; color: var(--red-d); border: 1px solid #f6c9c7; }\n.alertWarn { background: #fff8e6; color: #92611a; border: 1px solid #f1deb0; }\n\n/* GATE */\n.gate {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 48px 32px;\n  text-align: center;\n  max-width: 560px;\n  margin: 24px auto;\n}\n.gateTitle { font-size: 26px; font-weight: 800; margin: 0 0 10px; }\n.gateBody { font-size: 15.5px; color: var(--muted); line-height: 1.6; margin: 0 0 22px; }\n\n/* BUTTONS */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--red);\n  color: #fff;\n  border: none;\n  font-weight: 800;\n  font-size: 15px;\n  padding: 12px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background .15s;\n}\n.btn:hover { background: var(--red-d); }\n.btn:disabled { opacity: .55; cursor: default; }\n.btnGhost {\n  display: inline-flex;\n  align-items: center;\n  background: #fff;\n  color: var(--ink);\n  border: 1px solid var(--line);\n  font-weight: 800;\n  font-size: 14px;\n  padding: 10px 18px;\n  border-radius: 12px;\n  cursor: pointer;\n}\n.btnGhost:hover { border-color: #c9ccd1; }\n\n.backBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: var(--muted);\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 4px 0;\n  margin-bottom: 14px;\n}\n.backBtn:hover { color: var(--ink); }\n.backBtn svg { width: 18px; height: 18px; }\n\n/* DETAIL */\n.detailHead { margin-bottom: 20px; }\n.detailHead .catPill { margin-bottom: 10px; }\n.privacyNote {\n  font-size: 13px;\n  color: var(--muted);\n  margin: 8px 0 0;\n  font-style: italic;\n}\n.detailGrid {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 22px;\n  margin-bottom: 26px;\n}\n.detailMain { display: flex; flex-direction: column; gap: 18px; }\n.block {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 20px 22px;\n}\n.blockTitle { font-size: 16px; font-weight: 800; margin: 0 0 12px; }\n.blockText { font-size: 15px; color: #2a2f34; line-height: 1.6; margin: 0; white-space: pre-line; }\n\n.photoGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  gap: 12px;\n}\n.photoCell {\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  aspect-ratio: 4 / 3;\n  background: var(--bg);\n  border: 1px solid var(--line);\n}\n.photoCell img { width: 100%; height: 100%; object-fit: cover; display: block; }\n.photoPlaceholder {\n  display: flex; align-items: center; justify-content: center;\n  width: 100%; height: 100%; color: #b8bcc2;\n}\n.photoPlaceholder svg { width: 30px; height: 30px; }\n.photoSlot {\n  position: absolute; left: 0; right: 0; bottom: 0;\n  background: linear-gradient(transparent, rgba(0,0,0,.62));\n  color: #fff; font-size: 11px; font-weight: 700;\n  padding: 14px 8px 6px; text-transform: capitalize;\n}\n\n.detailSide { display: flex; flex-direction: column; gap: 16px; }\n.factCard {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 20px 22px;\n  position: sticky;\n  top: 84px;\n}\n\n.dl { display: grid; grid-template-columns: auto 1fr; gap: 8px 16px; margin: 0; }\n.dl dt { font-size: 13px; color: var(--muted); font-weight: 700; }\n.dl dd { font-size: 14px; margin: 0; text-align: right; font-weight: 600; text-transform: capitalize; }\n\n/* QUOTE FORM */\n.quoteCard {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 26px 26px 28px;\n}\n.quoteTitle { font-size: 22px; font-weight: 800; margin: 0 0 6px; }\n\n.lineHead, .lineRow {\n  display: grid;\n  grid-template-columns: 1fr 80px 130px 110px 34px;\n  gap: 10px;\n  align-items: center;\n}\n.lineHead {\n  margin: 16px 0 8px;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: .04em;\n  color: var(--muted);\n}\n.lineRow { margin-bottom: 8px; }\n.lhDesc {}\n.lhQty { text-align: left; }\n.lhUnit {}\n.lhTotal { text-align: right; }\n.lhDel {}\n.lineTotalCell { font-weight: 800; font-size: 15px; }\n.lineDel {\n  background: var(--bg);\n  border: 1px solid var(--line);\n  color: var(--muted);\n  width: 32px; height: 32px;\n  border-radius: 8px;\n  font-size: 20px; line-height: 1;\n  cursor: pointer;\n}\n.lineDel:hover { color: var(--red); border-color: #f6c9c7; }\n.addLine {\n  background: none; border: none; color: var(--red);\n  font-weight: 800; font-size: 14px; cursor: pointer;\n  padding: 6px 0; margin: 2px 0 6px;\n}\n\n.input {\n  width: 100%;\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 10px 12px;\n  font: inherit;\n  font-size: 14px;\n  background: #fff;\n  color: var(--ink);\n  box-sizing: border-box;\n}\n.input:focus { outline: none; border-color: var(--red); box-shadow: 0 0 0 3px rgba(232,35,43,.12); }\n\n.quoteMetaGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 14px;\n  margin: 18px 0 4px;\n}\n.field { display: flex; flex-direction: column; gap: 6px; }\n.field > span { font-size: 13px; font-weight: 700; color: var(--muted); }\n\n.totals {\n  margin: 18px 0 4px;\n  border-top: 1px solid var(--line);\n  padding-top: 14px;\n  max-width: 320px;\n  margin-left: auto;\n}\n.totalRow {\n  display: flex; justify-content: space-between;\n  font-size: 14px; color: var(--muted); font-weight: 600;\n  padding: 4px 0;\n}\n.totalGrand {\n  font-size: 18px; color: var(--ink); font-weight: 800;\n  border-top: 1px solid var(--line); margin-top: 6px; padding-top: 10px;\n}\n.quoteActions { display: flex; justify-content: flex-end; margin-top: 18px; }\n\n/* E4 — two-sided payment breakdown (company quote builder) */\n.breakdown {\n  margin: 20px 0 4px;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 18px 20px;\n  background: linear-gradient(180deg, #fff 0%, var(--bg) 100%);\n}\n.bkHead {\n  display: flex; align-items: center; justify-content: space-between;\n  gap: 12px; flex-wrap: wrap; margin-bottom: 6px;\n}\n.bkTitle { font-size: 15px; font-weight: 800; color: var(--ink); }\n.modeBadge {\n  display: inline-flex; align-items: center; gap: 6px;\n  font-size: 12px; font-weight: 800; letter-spacing: .02em;\n  padding: 6px 12px; border-radius: 999px;\n}\n.modeBadge svg { width: 14px; height: 14px; }\n.modeMilestone { background: #e7f0ff; color: #1d4ed8; }\n.modeFull { background: #e7f8ee; color: var(--green); }\n.bkRow {\n  display: flex; align-items: center; justify-content: space-between;\n  gap: 16px; padding: 12px 0; border-top: 1px solid var(--line);\n}\n.bkRow:first-of-type { border-top: none; }\n.bkLabel { display: flex; flex-direction: column; gap: 2px; }\n.bkName { font-size: 14px; font-weight: 700; color: var(--ink); }\n.bkHint { font-size: 12.5px; color: var(--muted); font-weight: 600; }\n.bkVal { font-size: 17px; font-weight: 800; color: var(--ink); white-space: nowrap; }\n.bkValClient { color: var(--ink); }\n.bkRowNet {\n  background: #fbfdfb; margin: 0 -20px -2px; padding: 14px 20px;\n  border-top: 1px solid var(--line); border-radius: 0 0 16px 16px;\n}\n.bkValNet { color: var(--green); }\n.bkNote {\n  margin: 12px 0 0; font-size: 12.5px; color: var(--muted);\n  font-weight: 600; line-height: 1.5;\n}\n\n/* MY QUOTES */\n.quoteList { display: flex; flex-direction: column; gap: 12px; }\n.quoteRow {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n}\n.quoteRowMain { flex: 1; min-width: 160px; display: flex; flex-direction: column; gap: 2px; }\n.quoteRef { font-weight: 800; font-size: 15px; }\n.quoteSubtitle { font-size: 13px; color: var(--muted); font-weight: 600; }\n.quoteRowMeta { display: flex; flex-direction: column; align-items: flex-end; gap: 2px; }\n.quoteAmount { font-weight: 800; font-size: 16px; }\n.quoteDays { font-size: 12.5px; color: var(--muted); font-weight: 600; }\n.statusPill {\n  font-size: 12px; font-weight: 800; letter-spacing: .03em;\n  padding: 6px 12px; border-radius: 999px;\n  background: var(--bg); color: var(--muted);\n  text-transform: uppercase;\n}\n.st_draft { background: #eef0f2; color: #5a6168; }\n.st_submitted { background: #e7f0ff; color: #1d4ed8; }\n.st_selected { background: #e7f8ee; color: var(--green); }\n.st_rejected { background: #fff0ef; color: var(--red-d); }\n.st_expired, .st_withdrawn { background: #f3f0e7; color: #92611a; }\n\n/* =========================================================================\n   DASHBOARD (lightweight CRM)\n   ========================================================================= */\n\n/* KPI cards */\n.kpiRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 14px;\n  margin: 0 0 26px;\n}\n.kpiCard {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  position: relative;\n  overflow: hidden;\n  transition: box-shadow .15s, transform .15s, border-color .15s;\n}\n.kpiCard:hover {\n  box-shadow: 0 14px 34px rgba(15, 18, 20, 0.08);\n  transform: translateY(-2px);\n  border-color: #d7dadf;\n}\n.kpiIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: #fff0ef;\n  color: var(--red);\n  margin-bottom: 8px;\n}\n.kpiIcon svg { width: 20px; height: 20px; }\n.kpiNum { font-size: 30px; font-weight: 800; line-height: 1.05; }\n.kpiLabel { font-size: 13.5px; font-weight: 700; color: var(--ink); }\n.kpiHint { font-size: 12.5px; color: var(--muted); font-weight: 600; }\n.kpiCardMoney {\n  background: linear-gradient(160deg, #ffffff 0%, #f3fbf5 100%);\n  border-color: #cdebd6;\n}\n.kpiCardMoney .kpiIcon { background: #e7f8ee; color: var(--green); }\n.kpiCardMoney .kpiNum { color: var(--green); }\n\n/* Dashboard sections */\n.dashBlock { margin: 0 0 28px; }\n.dashBlockHead {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 0 12px;\n}\n.dashTitle { font-size: 18px; font-weight: 800; margin: 0; }\n.dashCount {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--bg);\n  border: 1px solid var(--line);\n  font-size: 12.5px;\n  font-weight: 800;\n  color: var(--muted);\n}\n.dashTotalBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--green);\n  background: #e7f8ee;\n  border-radius: 999px;\n  padding: 6px 14px;\n}\n.dashTotalBadge svg { width: 15px; height: 15px; }\n\n.dashList { display: flex; flex-direction: column; gap: 10px; }\n.dashItem {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 15px 18px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  transition: border-color .15s;\n}\n.dashItem:hover { border-color: #d7dadf; }\n.dashItemMain { flex: 1; min-width: 180px; display: flex; flex-direction: column; gap: 3px; }\n.dashItemTitle {\n  font-size: 15px;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.dashItemSub { font-size: 13px; color: var(--muted); font-weight: 600; line-height: 1.4; }\n.dashItemAmount { font-size: 16px; font-weight: 800; white-space: nowrap; }\n\n/* Milestones grouped per contract */\n.msGroup {\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  background: #fff;\n  padding: 16px 18px;\n  margin-bottom: 12px;\n}\n.msGroupHead {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding-bottom: 12px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid var(--line);\n}\n.msGroupTitle { font-size: 15px; font-weight: 800; }\n.msGroupSub { font-size: 13px; color: var(--muted); font-weight: 700; }\n.msRow {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--line);\n}\n.msRow:last-child { border-bottom: none; padding-bottom: 2px; }\n.msTag {\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n  color: var(--teal);\n  background: #e6f4f2;\n  border-radius: 6px;\n  padding: 2px 7px;\n}\n\n/* extra status-pill colors for contracts / milestones / payouts */\n.st_active { background: #e7f8ee; color: var(--green); }\n.st_in_cancellation_period { background: #fff8e6; color: #92611a; }\n.st_completed { background: #eef0f2; color: #5a6168; }\n.st_cancelled { background: #fff0ef; color: var(--red-d); }\n.st_ready { background: #eef0f2; color: #5a6168; }\n.st_in_progress { background: #e7f0ff; color: #1d4ed8; }\n.st_submitted_for_review { background: #f3ecff; color: #6d28d9; }\n.st_paid { background: #e7f8ee; color: var(--green); }\n.st_pending { background: #fff8e6; color: #92611a; }\n.st_transferred { background: #e7f8ee; color: var(--green); }\n.st_reversed { background: #fff0ef; color: var(--red-d); }\n\n/* AI quote-drafting assistant (DRAFT ONLY) */\n.aiBox {\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);\n  padding: 16px;\n  margin: 4px 0 18px;\n}\n.aiHead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n.aiTitle { display: block; font-size: 15px; font-weight: 800; color: var(--ink); }\n.aiHint { display: block; margin-top: 3px; font-size: 13px; color: var(--muted); max-width: 520px; }\n.aiFallback {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #fff8e6;\n  color: #92611a;\n  font-size: 13px;\n  border: 1px solid #f3e3b3;\n}\n.aiFollow {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #eef4ff;\n  color: #1d4ed8;\n  font-size: 13px;\n  border: 1px solid #cfe0ff;\n}\n\n@media (max-width: 880px) {\n  .detailGrid { grid-template-columns: 1fr; }\n  .factCard { position: static; }\n  .lineHead { display: none; }\n  .lineRow { grid-template-columns: 1fr 1fr; grid-auto-rows: auto; }\n  .lhTotal { text-align: left; }\n  .aiHead { flex-direction: column; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `CompanyProjects-page-QRM5E`,
	"wrap": `CompanyProjects-wrap-IxaFF`,
	"topbar": `CompanyProjects-topbar-aSbJZ`,
	"brandRow": `CompanyProjects-brandRow-DTtj8`,
	"eyebrow": `CompanyProjects-eyebrow-LmZlo`,
	"greeting": `CompanyProjects-greeting-yiKQO`,
	"topActions": `CompanyProjects-topActions-VcoD6`,
	"iconBtn": `CompanyProjects-iconBtn-fK2n1`,
	"iconGlyph": `CompanyProjects-iconGlyph-lYFGI`,
	"badge": `CompanyProjects-badge-YaIFE`,
	"sectionTitle": `CompanyProjects-sectionTitle-kipHg`,
	"feedRow": `CompanyProjects-feedRow-bIZSw`,
	"feedMain": `CompanyProjects-feedMain-Ap0iX`,
	"feedTitle": `CompanyProjects-feedTitle-O6QPq`,
	"feedSub": `CompanyProjects-feedSub-YpvGG`,
	"dot": `CompanyProjects-dot-MlMYX`,
	"newTag": `CompanyProjects-newTag-tJbQI`,
	"openHint": `CompanyProjects-openHint-eZkTE`,
	"tabs": `CompanyProjects-tabs-GH4EI`,
	"tab": `CompanyProjects-tab-PrLaQ`,
	"tabOn": `CompanyProjects-tabOn-QVs1q`,
	"body": `CompanyProjects-body-WO5_C`,
	"loading": `CompanyProjects-loading-i0amn`,
	"headRow": `CompanyProjects-headRow-gF7Yi`,
	"h1": `CompanyProjects-h1-AX83m`,
	"sub": `CompanyProjects-sub-yUPlL`,
	"summaryRow": `CompanyProjects-summaryRow-Rit7_`,
	"summaryCard": `CompanyProjects-summaryCard-pfnmc`,
	"summaryCardWide": `CompanyProjects-summaryCardWide-jbomY`,
	"summaryNum": `CompanyProjects-summaryNum-DbjJf`,
	"summaryLabel": `CompanyProjects-summaryLabel-HguGS`,
	"summaryCompany": `CompanyProjects-summaryCompany-_xpiZ`,
	"grid": `CompanyProjects-grid-q1H7c`,
	"card": `CompanyProjects-card-XP6TA`,
	"cardTop": `CompanyProjects-cardTop-TflUr`,
	"catPill": `CompanyProjects-catPill-b3zcc`,
	"scorePill": `CompanyProjects-scorePill-oCbfO`,
	"cardTitle": `CompanyProjects-cardTitle-eNtqC`,
	"cardMetaRow": `CompanyProjects-cardMetaRow-xZRCW`,
	"cardMeta": `CompanyProjects-cardMeta-FTwmq`,
	"cardFoot": `CompanyProjects-cardFoot-H2Qew`,
	"cardRef": `CompanyProjects-cardRef-TXLKn`,
	"cardCta": `CompanyProjects-cardCta-pZV5h`,
	"empty": `CompanyProjects-empty-FCjkJ`,
	"emptyImg": `CompanyProjects-emptyImg-zn3xJ`,
	"emptyTitle": `CompanyProjects-emptyTitle-ltWnl`,
	"emptyBody": `CompanyProjects-emptyBody-NWWZD`,
	"alertErr": `CompanyProjects-alertErr-NaPA4`,
	"alertWarn": `CompanyProjects-alertWarn-uWNtq`,
	"gate": `CompanyProjects-gate-xoLws`,
	"gateTitle": `CompanyProjects-gateTitle-xw62t`,
	"gateBody": `CompanyProjects-gateBody-w8Vmb`,
	"btn": `CompanyProjects-btn-iuTM4`,
	"btnGhost": `CompanyProjects-btnGhost-j3f4a`,
	"backBtn": `CompanyProjects-backBtn-fGs8Q`,
	"detailHead": `CompanyProjects-detailHead-juhKC`,
	"privacyNote": `CompanyProjects-privacyNote-AQp4U`,
	"detailGrid": `CompanyProjects-detailGrid-RITRZ`,
	"detailMain": `CompanyProjects-detailMain-M27UJ`,
	"block": `CompanyProjects-block-sAYms`,
	"blockTitle": `CompanyProjects-blockTitle-zwJFc`,
	"blockText": `CompanyProjects-blockText-rn8HU`,
	"photoGrid": `CompanyProjects-photoGrid-Slerj`,
	"photoCell": `CompanyProjects-photoCell-SzArm`,
	"photoPlaceholder": `CompanyProjects-photoPlaceholder-GKwy3`,
	"photoSlot": `CompanyProjects-photoSlot-ChrY6`,
	"detailSide": `CompanyProjects-detailSide-PU7_A`,
	"factCard": `CompanyProjects-factCard-oUnAo`,
	"dl": `CompanyProjects-dl-KL0qp`,
	"quoteCard": `CompanyProjects-quoteCard-nQ87W`,
	"quoteTitle": `CompanyProjects-quoteTitle-cCfVy`,
	"lineHead": `CompanyProjects-lineHead-LQ4SF`,
	"lineRow": `CompanyProjects-lineRow-y9HXn`,
	"lhDesc": `CompanyProjects-lhDesc-lTuZ1`,
	"lhQty": `CompanyProjects-lhQty-ku9wa`,
	"lhUnit": `CompanyProjects-lhUnit-lAecL`,
	"lhTotal": `CompanyProjects-lhTotal-jCGdQ`,
	"lhDel": `CompanyProjects-lhDel-TlWba`,
	"lineTotalCell": `CompanyProjects-lineTotalCell-hHKwd`,
	"lineDel": `CompanyProjects-lineDel-X1xut`,
	"addLine": `CompanyProjects-addLine-UkEwo`,
	"input": `CompanyProjects-input-cazeM`,
	"quoteMetaGrid": `CompanyProjects-quoteMetaGrid-psKrW`,
	"field": `CompanyProjects-field-yMLKS`,
	"totals": `CompanyProjects-totals-q0iD4`,
	"totalRow": `CompanyProjects-totalRow-dmxm0`,
	"totalGrand": `CompanyProjects-totalGrand-Jm9hx`,
	"quoteActions": `CompanyProjects-quoteActions-Z3Kl2`,
	"breakdown": `CompanyProjects-breakdown-OBsla`,
	"bkHead": `CompanyProjects-bkHead-QlF4V`,
	"bkTitle": `CompanyProjects-bkTitle-anMlr`,
	"modeBadge": `CompanyProjects-modeBadge-yyF6Q`,
	"modeMilestone": `CompanyProjects-modeMilestone-O0Bue`,
	"modeFull": `CompanyProjects-modeFull-mQt0q`,
	"bkRow": `CompanyProjects-bkRow-imwKE`,
	"bkLabel": `CompanyProjects-bkLabel-aF4es`,
	"bkName": `CompanyProjects-bkName-x2k4N`,
	"bkHint": `CompanyProjects-bkHint-PeH1A`,
	"bkVal": `CompanyProjects-bkVal-Mext9`,
	"bkValClient": `CompanyProjects-bkValClient-bq1zM`,
	"bkRowNet": `CompanyProjects-bkRowNet-d9NUS`,
	"bkValNet": `CompanyProjects-bkValNet-let1M`,
	"bkNote": `CompanyProjects-bkNote-_KCB7`,
	"quoteList": `CompanyProjects-quoteList-e5HhD`,
	"quoteRow": `CompanyProjects-quoteRow-vRZlE`,
	"quoteRowMain": `CompanyProjects-quoteRowMain-A10l9`,
	"quoteRef": `CompanyProjects-quoteRef-cF87Z`,
	"quoteSubtitle": `CompanyProjects-quoteSubtitle-Ib63n`,
	"quoteRowMeta": `CompanyProjects-quoteRowMeta-CpbHd`,
	"quoteAmount": `CompanyProjects-quoteAmount-JCMQG`,
	"quoteDays": `CompanyProjects-quoteDays-xkwIW`,
	"statusPill": `CompanyProjects-statusPill-M2_yc`,
	"st_draft": `CompanyProjects-st_draft-c2ahd`,
	"st_submitted": `CompanyProjects-st_submitted-ddgTt`,
	"st_selected": `CompanyProjects-st_selected-QePxP`,
	"st_rejected": `CompanyProjects-st_rejected-wQlQj`,
	"st_expired": `CompanyProjects-st_expired-ZIi_b`,
	"st_withdrawn": `CompanyProjects-st_withdrawn-jWpnL`,
	"kpiRow": `CompanyProjects-kpiRow-_qZY_`,
	"kpiCard": `CompanyProjects-kpiCard-Mfwj6`,
	"kpiIcon": `CompanyProjects-kpiIcon-_2U6l`,
	"kpiNum": `CompanyProjects-kpiNum-G74wi`,
	"kpiLabel": `CompanyProjects-kpiLabel-Ojuko`,
	"kpiHint": `CompanyProjects-kpiHint-hdCNZ`,
	"kpiCardMoney": `CompanyProjects-kpiCardMoney-kPpKj`,
	"dashBlock": `CompanyProjects-dashBlock-AQqAT`,
	"dashBlockHead": `CompanyProjects-dashBlockHead-CqNR_`,
	"dashTitle": `CompanyProjects-dashTitle-O7DBV`,
	"dashCount": `CompanyProjects-dashCount-wt5vQ`,
	"dashTotalBadge": `CompanyProjects-dashTotalBadge-hrGHF`,
	"dashList": `CompanyProjects-dashList-VV0rt`,
	"dashItem": `CompanyProjects-dashItem-jXd8c`,
	"dashItemMain": `CompanyProjects-dashItemMain-x98x0`,
	"dashItemTitle": `CompanyProjects-dashItemTitle-DTo4v`,
	"dashItemSub": `CompanyProjects-dashItemSub-LlZep`,
	"dashItemAmount": `CompanyProjects-dashItemAmount-ff7K5`,
	"msGroup": `CompanyProjects-msGroup-JngJj`,
	"msGroupHead": `CompanyProjects-msGroupHead-g5vDm`,
	"msGroupTitle": `CompanyProjects-msGroupTitle-qvAnZ`,
	"msGroupSub": `CompanyProjects-msGroupSub-DI8Ak`,
	"msRow": `CompanyProjects-msRow-IuCdF`,
	"msTag": `CompanyProjects-msTag-I86hX`,
	"st_active": `CompanyProjects-st_active-F4CxA`,
	"st_in_cancellation_period": `CompanyProjects-st_in_cancellation_period-ZOkvJ`,
	"st_completed": `CompanyProjects-st_completed-iuW7D`,
	"st_cancelled": `CompanyProjects-st_cancelled-gxZrw`,
	"st_ready": `CompanyProjects-st_ready-faNxx`,
	"st_in_progress": `CompanyProjects-st_in_progress-Mi0wJ`,
	"st_submitted_for_review": `CompanyProjects-st_submitted_for_review-UQ8dN`,
	"st_paid": `CompanyProjects-st_paid-cRqW2`,
	"st_pending": `CompanyProjects-st_pending-yMKhq`,
	"st_transferred": `CompanyProjects-st_transferred-yE_DA`,
	"st_reversed": `CompanyProjects-st_reversed-FGf0V`,
	"aiBox": `CompanyProjects-aiBox-iPRXH`,
	"aiHead": `CompanyProjects-aiHead-v05Dq`,
	"aiTitle": `CompanyProjects-aiTitle-x8xvX`,
	"aiHint": `CompanyProjects-aiHint-lgImi`,
	"aiFallback": `CompanyProjects-aiFallback-DO_zO`,
	"aiFollow": `CompanyProjects-aiFollow-NBJl5`
};
module.exports = ___CSS_LOADER_EXPORT___;
